export default __webpack_public_path__ + "static/logo25-e73740013e5338e6e176a3afaac97f51.png";